import { useQueryClient } from "@tanstack/react-query";
import { GetDietitianAccountResponse } from "@client/settings/getDietitianAccountAPI";
import { useEffect, useState } from "react";
import { ApiResponse } from "@typeDefinitions/Api";
import { settingsKeys } from "@hooks/queries/settings/settingsKeys";

const useAccountForUserDotCom = () => {
  const queryKey = settingsKeys.dietitianAccount();

  const queryClient = useQueryClient();

  const [data, setData] = useState<
    ApiResponse<GetDietitianAccountResponse> | undefined
  >(() => queryClient.getQueryData(queryKey));
  const account = data?.data;

  useEffect(() => {
    const unsubscribe = queryClient.getQueryCache().subscribe(event => {
      if (
        event?.query?.queryKey &&
        JSON.stringify(event.query.queryKey) === JSON.stringify(queryKey) &&
        event.type === "updated"
      ) {
        setData(queryClient.getQueryData(queryKey));
      }
    });

    return () => unsubscribe();
  }, [queryClient, queryKey]);

  return { account };
};

export default useAccountForUserDotCom;
